import ArrondissementPage from "../ArrondissementPage";
import { arrondissementsData } from "@/mocks/arrondissements";

export default function ParisArrRivegauchePage() {
  const data = arrondissementsData.find((a) => a.slug === "rive-gauche")!;
  return <ArrondissementPage data={data} />;
}
